import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { MaintenancePage } from "@lg-cfa/components/src/MaintenancePage";
import { FeatureFlags } from "@lg-cfa/enums";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

const RootLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { t } = useTranslation();
    const isInMaintenanceMode = useFeatureIsOn(
        FeatureFlags.MaintenanceMode as string,
    );

    if (isInMaintenanceMode) {
        return (
            <MaintenancePage
                title={t("maintenance.title")}
                description={t("maintenance.text")}
                buttonText={t("maintenance.button")}
            />
        );
    }

    return <>{children}</>;
};

export default RootLayout;
